import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Fetch } from "../../../shared/Fetch";
import { EmptyTenderClientCategory, ITenderClientCategory } from "./TenderClientCategory";
import { JVInput } from "../../../shared/JVInput";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { InputTextarea } from "primereact/inputtextarea";

interface Iprops {
  singleData: ITenderClientCategory;
  open: boolean;
  hideDialog: () => void;
  toast: any;
  reload: boolean;
  setReload: (is: boolean) => void;
}

export const Form = (props: Iprops) => {
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState<string>("");
  const TenderClientCategorySchema = yup.object({
    category_Name: yup.string().trim().required("Category Name is required"),
  });

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors, isDirty },
  } = useForm<ITenderClientCategory>({
    resolver: yupResolver(TenderClientCategorySchema),
    defaultValues: { category_Name: "" },
  });

  useEffect(() => {
    if (props.open) {
      reset({ category_Name: props.singleData?.category_Name || "", description: props.singleData?.description });
    }
    setDescription(props.singleData?.description || "");
  }, [props.open, props.singleData, reset]);

  const onSubmit = async (data: ITenderClientCategory) => {
    try {
      setLoading(true);

      const isEdit = !!props.singleData?.id;
      const descriptionChanged = description !== (props.singleData?.description ?? "");

      if (isEdit && !isDirty && !descriptionChanged) {
        props.toast.current.show({ severity: "info", summary: "No Changes", detail: "Nothing was changed." });
        props.hideDialog();
        return;
      }

      const method = isEdit ? "PUT" : "POST";
      const endpoint = isEdit ? `Tender_Client_Category/${props.singleData.id}` : "Tender_Client_Category/AddTenderClientCategory";
      const message = isEdit ? "RFP Client Category Updated Successfully" : "RFP Client Category Added Successfully";
      data.description = description;
      const response = await Fetch(endpoint, method, data, null, props.toast);

      if (response) {
        props.toast.current.show({ severity: "success", summary: "Success", detail: message, life: 3000 });
        props.setReload(!props.reload);
        props.hideDialog();
        setDescription("");
        reset(EmptyTenderClientCategory);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const onHide = () => {
    props.hideDialog();
    reset(EmptyTenderClientCategory);
  };

  return (
    <Dialog visible={props.open} onHide={onHide} header={props.singleData?.id ? "Update RFP Client Category" : "Add RFP Client Category"} style={{ width: "40rem" }}>
      <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
        <JVInput required label="Category Name" control={control} name="category_Name" error={errors.category_Name?.message} />
        <div className="field col-12">
          <label>Category Description</label>
          <InputTextarea value={description} onChange={(e) => setDescription(e.target.value)} rows={4} cols={30} className="w-full" placeholder="Enter task description" />
        </div>
        <div className="col-12 flex gap-4 justify-content-end">
          <Button style={{ width: "100px" }} label={props.singleData?.id ? "UPDATE" : "SAVE"} type="submit" loading={loading} />
          <Button style={{ width: "100px" }} label="CLOSE" type="button" onClick={onHide} className="p-button-outlined" />
        </div>
      </form>
    </Dialog>
  );
};
